import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useContext } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { StepContext } from '../Step';
import { Base } from '../Base';
import { stepConnectorStyles } from './StepConnector.styles';
import { stepConnectorTheme } from './StepConnector.stylex';
export const StepConnector = forwardRef(function StepConnector(props, forwardedRef) {
    const { styles, sx, children, orientation: orientationProp, stepLabelPosition: stepLabelPositionProp, textPosition: textPositionProp, ...other } = props;
    const { combineStyles, getStyles, globalStyles } = useStyles({
        name: 'StepConnector',
        styles: [stepConnectorStyles, styles],
    });
    const stepContext = useContext(StepContext);
    const orientation = orientationProp ?? stepContext?.orientation ?? 'horizontal';
    const stepLabelPosition = stepLabelPositionProp ?? stepContext?.labelPosition ?? 'right';
    const textPosition = (orientation === 'horizontal' ? textPositionProp : undefined) ?? 'middle';
    const renderLine = (props) => (_jsx("div", { ...getStyles('line', orientation === 'horizontal' && [
            'line$horizontal',
            props?.cutStart && `line$horizontal$cutStart`,
            props?.cutEnd && `line$horizontal$cutEnd`,
            stepLabelPosition === 'right' &&
                stepContext?.hasText &&
                'line$horizontal$rightLabel$hasText',
            !!children &&
                textPosition === 'middle' &&
                `line$horizontal$minLength`,
        ], orientation === 'vertical' && [
            'line$vertical',
            props?.cutStart && `line$vertical$cutStart`,
            props?.cutEnd && `line$vertical$cutEnd`,
            !!children &&
                textPosition === 'middle' &&
                `line$vertical$minLength`,
        ], stepContext?.completed && 'line$completed') }));
    const renderText = () => (_jsx("div", { ...getStyles('text', orientation === 'horizontal' && `text$horizontal`, orientation === 'vertical' && `text$vertical`, stepContext?.completed && 'text$completed'), children: children }));
    const renderInner = () => children ? (textPosition === 'top' ? (_jsxs(_Fragment, { children: [renderText(), renderLine()] })) : textPosition === 'bottom' ? (_jsxs(_Fragment, { children: [renderLine(), renderText()] })) : (_jsxs(_Fragment, { children: [renderLine({ cutEnd: true }), renderText(), renderLine({ cutStart: true })] }))) : (renderLine());
    return (_jsx(Base, { ...other, sx: [
            stepConnectorTheme,
            globalStyles,
            combineStyles('host', `host$${orientation}$${stepLabelPosition}Label`),
            sx,
        ], ref: forwardedRef, children: _jsx("div", { ...getStyles('container', `container$${orientation}`, orientation === 'horizontal' &&
                `container$horizontal$${textPosition}Text`), children: renderInner() }) }));
});
